/**
 * Created by Owner on 2016/8/9.
 */
import {Component} from '@angular/core';
import {NavController, AlertController, ViewController, NavParams, LoadingController} from 'ionic-angular';
import {AppConfigService} from "../../services/appConfig.service";
import {BetDetailsPage} from "../betDetails/betDetails";
import {UserService} from "../../services/user.services";
import {TabsPage} from "../tabs/tabs";
import {WithdrawDetailPage} from "../withdrawDetail/withdrawDetail";

@Component({
    templateUrl: 'withdrawList.html',
    selector: 'withdraw-list-page',
})
export class WithdrawListPage {
    recordList: any = [];
    infiniteScrollBoolean: boolean = true;
    totalNum: number = 0;
    requestData: any;
    stateNameFn: any = {
        0: " Đã gửi",
        1: " Đang xử lý",
        2: " Đang chờ duyệt",
        4: " Thành công",
        5: " Thất bại"
    };

    constructor(private navParams: NavParams, private nav: NavController, private alertCtrl: AlertController,
                private userService: UserService, public viewCtrl: ViewController,
                private loadingCtrl: LoadingController) {
        this.requestData = navParams.get("requestData");
        this.loadingData(navParams.get("data"));
    }

    // goDetail(index: string) {
    //   this.nav.push(BetDetailsPage, {
    //     revoke: true,
    //     betId: index
    //   });
    // }

    doRefresh(refresher) {
        this.getFirstData(refresher);
    }

    getFirstData(refresher: any = null) {
        let dataParams = this.requestData;
        this.userService.WithdrawalSearch(dataParams, this.alertCtrl).then(data => {
            if (!data["msg"]) {
                this.loadingData(data);
                if (refresher) {
                    refresher.complete();
                    this.infiniteScrollBoolean = true;
                }
            }
        });
    }

    doInfinite(infiniteScroll) {
        let dataParams = this.requestData;
        infiniteScroll.enable(false);
        setTimeout(() => {
            this.userService.WithdrawalSearchNext(dataParams, this).then(data => {
                if (!data["msg"]) {
                    data["reslist"].map(item => {
                        item["statusname"] = this.stateNameFn[item["status"]];
                        item["applytime"] = item["applytime"].replace(/-/g,'/');
                        return item;
                    });
                    this.totalNum = data["totalrecord"];
                    this.recordList = this.recordList.concat(data["reslist"]);
                    infiniteScroll.complete();
                    infiniteScroll.enable(true);
                } else {
                    infiniteScroll.enable(true);
                    this.infiniteScrollBoolean = false;
                }
            });
        }, 500);
    }

    //更新加工数据
    loadingData(data: any) {
        this.recordList = data["reslist"];
        this.totalNum = data["totalrecord"];
        this.recordList.map(item => {
            item["statusname"] = this.stateNameFn[item["status"]];
            item["applytime"] = item["applytime"].replace(/-/g,'/');
            return item;
        });
    }

    // ionViewWillEnter() {
    //   // this.getFirstData();
    // }

    dismiss() {
        this.viewCtrl.dismiss().catch(() => {
        });
    }

    gotoDetailWithdraw(item: any) {
        this.nav.push(WithdrawDetailPage, {
            paramItem: item
        });
    }
}



// WEBPACK FOOTER //
// ./src/pages/withdrawList/withdrawList.ts